import gql from 'graphql-tag';

export default id => gql`
  query {
    getAccountById(input: { id: "${id}" }) {
      id
      parentId
      customerSegment
      type
      subType
      salesChannel
      marketSegment
      sellingCompany
      lineOfBusiness
      legalEntity
      currency
      status
      reason
      effectiveDate
      organization
      commercialName
      clientId
      contacts {
        id
        roles
        salutation
        firstName
        middleName
        lastName
        position
        organization
        email
        identityDocument
        createdDate
        phones {
          type
          number
        }
      }
      addresses {
        id
        roles
        street
        extraLine
        landmark
        city
        state
        district
        country
        postalCode
        code
        createdDate
      }
      billingProfiles {
        id
        parentId
        billingDom
        billingSegment
        billingFrequency
        invoiceType
        invoiceDelivery
        paymentProfileId
      }
      paymentProfiles {
        id
        paymentTerm
        paymentMethod
        creditCards {
          cardToken
          cardExpiry
          last4CC
          merchant
        }
      }
      customAttributes {
        name
        value
      }
    }
  }
`;
